<template>
  <ListeReferentiel
    ref="liste"
    titre="Conditionnements"
    icone="bi-box-seam"
    ressource="conditionnements"
    tri-defaut="cond.nom"
    :options-tri="{ Nom: 'cond.nom', 'Date de création': 'cond.createdAt' }"
    placeholder="Nom du conditionnement…"
    unite="conditionnement(s)"
    vide="Aucun conditionnement enregistré."
    :colonnes="5"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_CONDITIONNEMENT')"
    libelle-creer="Nouveau conditionnement"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-sm-table-cell">Créé le</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: cond }">
      <td>{{ cond.nom }}</td>
      <td class="d-none d-sm-table-cell">{{ formatDate(cond.createdAt) }}</td>
      <td>
        <span :class="['badge', cond.isEnabled ? 'bg-success' : 'bg-secondary']">{{ cond.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_CONDITIONNEMENT', 'CONFIG_SUPPRESSION_CONDITIONNEMENT'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_CONDITIONNEMENT')"><a class="dropdown-item" href="#" @click.prevent="modifier(cond.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_CONDITIONNEMENT')"><a class="dropdown-item" href="#" @click.prevent="changerStatus(cond)">{{ cond.isEnabled ? 'Désactiver' : 'Activer' }}</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_CONDITIONNEMENT')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(cond)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api, { messageErreur, notifier } from '@/api';
import dayjs from 'dayjs';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeConditionnement',
  components: { ListeReferentiel },
  methods: {
    formatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY') : '—';
    },
    creation() {
      this.$router.push({ name: 'create_conditionnement' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_conditionnement', params: { id } });
    },
    async changerStatus(cond) {
      try {
        await api.updateItem('conditionnements', cond.id, { isEnabled: !cond.isEnabled });
        notifier(cond.isEnabled ? 'Conditionnement désactivé.' : 'Conditionnement activé.', 'success');
        this.$refs.liste.charger();
      } catch (err) {
        if (err?.response?.status !== 403) notifier(messageErreur(err, 'Le statut n\'a pas pu être changé.'), 'danger');
      }
    },
    supprimer(cond) {
      this.$refs.liste.supprimer({
        id: cond.id,
        titre: 'Supprimer le conditionnement',
        message: `Supprimer le conditionnement « ${cond.nom} » ?`,
        succes: 'Conditionnement supprimé.',
      });
    },
  },
};
</script>
